<template>
  <div>
    <header-slot>
      <template v-slot:content-right>
        <div class="mr-2">
          <!-- <b-button
            v-b-tooltip.hover.right="$t('Register New User')"
            to="register"
            variant="outline-success"
          >
            <div class="d-flex justify-content-between">
              <span v-t="'CREATE'"></span>
            </div>
          </b-button> -->
          <b-button
            variant="outline-primary"
            v-b-tooltip.hover.left="'Sincronizar con Antiguo Soft'"
            @click="sincronizeWithOldSoft"
          >
            <span>SINCRONIZAR</span>
          </b-button>
        </div>
      </template>
    </header-slot>
    <GridTable />
  </div>
</template>
<script>
/* SERVICES */
import { mapGetters } from "vuex";
import UserService from "@/views/users/views/list/services/users.services.js";
import GridTable from "@/views/users/views/list/components/GridTable.vue";

export default {
  name: "UserList",
  components: {
    GridTable,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
    async sincronizeWithOldSoft() {
      try {
        const confirm = await this.showConfirmSwal();
        if (confirm.isConfirmed) {
          this.addPreloader();
          const { data } = await UserService.getLasUserId({});
          if (data.length > 0) {
            const form_params = new URLSearchParams();
            form_params.append(
              "data",
              JSON.stringify({
                id: data[0].id,
                token: "sfgdshfiuhfgsd7w9t874w9erfhu54k435df",
              })
            );

            const data2 = await UserService.getNewsUsersOldSoft(form_params);
            if (data2.data.users.length > 0) {
              this.showToastSuccess(
                `${data2.data.users.length} usuarios nuevos encontrados.`,
                "Success"
              );
              const data3 = await UserService.insertNewsUsersOfOldSot({
                users: JSON.stringify(data2.data.users),
              });
              this.showToastSuccess("Nuevos Personales insertados", "Success");
              // } else {
              //   this.showToastSuccess(
              //     "No se encontraron nuevos Empleados",
              //     "Success"
              //   );
            }
          } else {
            this.showToastSuccess("No se encontraron registros", "Success");
          }
        }
      } catch (error) {
        this.showToastError();
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>
  
  
  